import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  private dataSource = new BehaviorSubject<any>(null);
  currentData$:any = this.dataSource.asObservable();

  constructor() {}

  // Send data
  setData(data: any) {
    this.dataSource.next(data);
  }

  // Optional: get current value instantly
  getData() {
    return this.dataSource.value;
  }
}